const loginForm = document.querySelector("#login-form");
const usernameInput = document.querySelector("#username");
const passwordInput = document.querySelector("#password");
const totpField = document.querySelector("#totp-field");
const totpCodeInput = document.querySelector("#totp-code");
const loginMessage = document.querySelector("#login-message");
const submitButton = loginForm.querySelector("button[type='submit']");

let secondFactorRequired = false;

function setLoginMessage(message, state = "neutral") {
  loginMessage.textContent = message;
  loginMessage.dataset.state = state;
}

function enterSecondFactorStep() {
  secondFactorRequired = true;
  totpField.hidden = false;
  totpCodeInput.required = true;
  submitButton.textContent = "Verify code";
  setLoginMessage("Password accepted. Enter your 2FA or recovery code.", "ok");
  totpCodeInput.focus();
}

function resetSecondFactorStep() {
  if (!secondFactorRequired) {
    return;
  }
  secondFactorRequired = false;
  totpField.hidden = true;
  totpCodeInput.required = false;
  totpCodeInput.value = "";
  submitButton.textContent = "Log in";
  setLoginMessage("");
}

usernameInput.addEventListener("input", resetSecondFactorStep);
passwordInput.addEventListener("input", resetSecondFactorStep);

loginForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  setLoginMessage(secondFactorRequired ? "Verifying code..." : "Checking credentials...");
  submitButton.disabled = true;
  try {
    const totpCode = totpCodeInput.value.trim();
    const response = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: usernameInput.value,
        password: passwordInput.value,
        ...(secondFactorRequired && totpCode ? { totp_code: totpCode } : {}),
      }),
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(body.detail || "Login failed");
    }
    if (body.totp_required) {
      enterSecondFactorStep();
      return;
    }
    window.location.assign("/");
  } catch (error) {
    setLoginMessage(error.message, "error");
  } finally {
    submitButton.disabled = false;
  }
});
